<!-- Page banner Area -->
<div class="page-banner bg-2">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-content">
                    <h2>FAQ</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>FAQ</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Page banner Area -->

<!-- FAQ Area -->
<section class="faq-area py-5" style="background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);" data-aos="fade-up"
    data-aos-duration="1000">
    <div class="container">
        <div class="text-center mb-5" data-aos="zoom-in" data-aos-delay="200">
            <span class="sub-title-modern">FAQ</span>
            <h2 class="fs-3 fw-bold">Frequently Asked Questions</h2>
            <p class="lead text-muted mt-3">Find answers to common questions about our logistics and shipping services
            </p>
        </div>

        <div class="faq-content">
            <div class="row align-items-start g-4">
                <div class="col-lg-6 col-md-12" data-aos="fade-right" data-aos-delay="200">
                    <div class="accordion" id="faqAccordionLeft">
                        <!-- FAQ Item 1 -->
                        <div class="accordion-item mb-3 border-0 shadow-sm rounded-3 overflow-hidden" data-aos="fade-up"
                            data-aos-delay="100">
                            <h2 class="accordion-header" id="headingOne">
                                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <i class="bi bi-truck me-2" style="color: #495057;"></i>
                                    What transport and logistics services do you offer?
                                </button>
                            </h2>
                            <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                                data-bs-parent="#faqAccordionLeft">
                                <div class="accordion-body">
                                    <p class="text-muted mb-0">We provide comprehensive logistics solutions including
                                        air freight, sea freight, road transportation, warehousing, and customs
                                        clearance. Our services cover 120+ countries with real-time tracking and 24/7
                                        customer support to ensure your cargo reaches its destination safely and on
                                        time.</p>
                                </div>
                            </div>
                        </div>

                        <!-- FAQ Item 2 -->
                        <div class="accordion-item mb-3 border-0 shadow-sm rounded-3 overflow-hidden" data-aos="fade-up"
                            data-aos-delay="200">
                            <h2 class="accordion-header" id="headingTwo">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    <i class="bi bi-shield-check me-2" style="color: #495057;"></i>
                                    How safe are my shipments with Lemonmode?
                                </button>
                            </h2>
                            <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                                data-bs-parent="#faqAccordionLeft">
                                <div class="accordion-body">
                                    <p class="text-muted mb-0">Security is our top priority. We use advanced packaging
                                        solutions, GPS tracking systems, and secure handling protocols. Our 98% success
                                        rate and comprehensive insurance options ensure your goods are protected
                                        throughout the entire journey.</p>
                                </div>
                            </div>
                        </div>

                        <!-- FAQ Item 3 -->
                        <div class="accordion-item mb-3 border-0 shadow-sm rounded-3 overflow-hidden" data-aos="fade-up"
                            data-aos-delay="300">
                            <h2 class="accordion-header" id="headingThree">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    <i class="bi bi-laptop me-2" style="color: #495057;"></i>
                                    Do you offer digital tracking solutions?
                                </button>
                            </h2>
                            <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                                data-bs-parent="#faqAccordionLeft">
                                <div class="accordion-body">
                                    <p class="text-muted mb-0">Yes! Our state-of-the-art digital platform provides
                                        real-time tracking, automated notifications, and detailed analytics. Access your
                                        shipment status anytime via web or mobile app. You'll receive updates at every
                                        milestone from pickup to delivery.</p>
                                </div>
                            </div>
                        </div>

                        <!-- FAQ Item 4 -->
                        <div class="accordion-item mb-3 border-0 shadow-sm rounded-3 overflow-hidden" data-aos="fade-up"
                            data-aos-delay="400">
                            <h2 class="accordion-header" id="headingFour">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    <i class="bi bi-star me-2" style="color: #6c757d;"></i>
                                    What makes Lemonmode the best logistics choice?
                                </button>
                            </h2>
                            <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                                data-bs-parent="#faqAccordionLeft">
                                <div class="accordion-body">
                                    <p class="text-muted mb-0">With 12+ years of experience, 5000+ happy clients, and
                                        coverage across 120+ countries, we combine expertise with innovation. Our
                                        customer-first approach, competitive pricing, and commitment to excellence set
                                        us apart from the competition.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-12" data-aos="fade-left" data-aos-delay="400">
                    <div class="accordion" id="faqAccordionRight">
                        <!-- FAQ Item 5 -->
                        <div class="accordion-item mb-3 border-0 shadow-sm rounded-3 overflow-hidden" data-aos="fade-up"
                            data-aos-delay="100">
                            <h2 class="accordion-header" id="headingFive">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                    <i class="bi bi-building me-2" style="color: #495057;"></i>
                                    Are you a modern and trusted logistics company?
                                </button>
                            </h2>
                            <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive"
                                data-bs-parent="#faqAccordionRight">
                                <div class="accordion-body">
                                    <p class="text-muted mb-0">Absolutely! We blend time-tested logistics expertise with
                                        cutting-edge technology. Our modern fleet, automated warehouses, and AI-powered
                                        route optimization ensure efficient operations while maintaining the personal
                                        touch our clients value.</p>
                                </div>
                            </div>
                        </div>

                        <!-- FAQ Item 6 -->
                        <div class="accordion-item mb-3 border-0 shadow-sm rounded-3 overflow-hidden" data-aos="fade-up"
                            data-aos-delay="200">
                            <h2 class="accordion-header" id="headingSix">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                    <i class="bi bi-globe me-2" style="color: #495057;"></i>
                                    Where do you serve clients around the world?
                                </button>
                            </h2>
                            <div id="collapseSix" class="accordion-collapse collapse" aria-labelledby="headingSix"
                                data-bs-parent="#faqAccordionRight">
                                <div class="accordion-body">
                                    <p class="text-muted mb-0">We operate across 120+ countries with strategic
                                        partnerships in major trade routes. From North America to Asia, Europe to
                                        Africa, our global network ensures seamless door-to-door delivery regardless of
                                        destination.</p>
                                </div>
                            </div>
                        </div>

                        <!-- FAQ Item 7 -->
                        <div class="accordion-item mb-3 border-0 shadow-sm rounded-3 overflow-hidden" data-aos="fade-up"
                            data-aos-delay="300">
                            <h2 class="accordion-header" id="headingSeven">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                                    <i class="bi bi-award me-2" style="color: #495057;"></i>
                                    What makes your service special globally?
                                </button>
                            </h2>
                            <div id="collapseSeven" class="accordion-collapse collapse" aria-labelledby="headingSeven"
                                data-bs-parent="#faqAccordionRight">
                                <div class="accordion-body">
                                    <p class="text-muted mb-0">Our unique combination of local expertise and global
                                        reach makes us special. We understand regional regulations, have multilingual
                                        support teams, and offer customized solutions for different markets while
                                        maintaining consistent service quality worldwide.</p>
                                </div>
                            </div>
                        </div>

                        <!-- FAQ Item 8 - NEW -->
                        <div class="accordion-item mb-3 border-0 shadow-sm rounded-3 overflow-hidden" data-aos="fade-up"
                            data-aos-delay="400">
                            <h2 class="accordion-header" id="headingEight">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                                    <i class="bi bi-currency-dollar me-2" style="color: #6c757d;"></i>
                                    How do you calculate shipping costs?
                                </button>
                            </h2>
                            <div id="collapseEight" class="accordion-collapse collapse" aria-labelledby="headingEight"
                                data-bs-parent="#faqAccordionRight">
                                <div class="accordion-body">
                                    <p class="text-muted mb-0">Shipping costs are calculated based on weight,
                                        dimensions, destination, and service type. We offer transparent pricing with no
                                        hidden fees. Get an instant quote through our online calculator or contact our
                                        team for customized shipping solutions tailored to your budget.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Quick Contact Banner -->
        <div class="row mt-5" data-aos="fade-up" data-aos-delay="200">
            <div class="col-12">
                <div class="rounded-4 p-4 text-dark text-center"
                    style="background: linear-gradient(135deg, #dee2e6 0%, #ced4da 100%); border: 2px solid #adb5bd;">
                    <h4 class="fw-bold mb-2">Still have questions?</h4>
                    <p class="mb-0" style="color: #495057;">Our logistics experts are ready to help you with any
                        specific inquiries</p>
                </div>
            </div>
        </div>

        <!-- FAQ Contact Form -->
        <div class="faq-form mt-5" data-aos="fade-up" data-aos-delay="300">
            <div class="card border-0 shadow-lg rounded-4 overflow-hidden">
                <div class="card-header py-4"
                    style="background: linear-gradient(135deg, #dee2e6 0%, #ced4da 100%); color: #495057; border-bottom: 2px solid #adb5bd;">
                    <div class="text-center">
                        <span class="badge px-3 py-2 rounded-pill mb-2"
                            style="background-color: #6c757d; color: white;">Get in Touch</span>
                        <h2 class="fs-4 fw-bold mb-0">Send Us Your Question</h2>
                    </div>
                </div>
                <div class="card-body p-4 p-lg-5">
                    <form id="contactForm" [formGroup]="contactFormGroup">
                        <div class="card border-0 contact-card">
                            <div class="card-body">
                                <div class="contact-card__hero text-center mb-4 mb-md-5">
                                    <!-- <div class="fs-3 text-black fw-semibold mb-2">Send us a message</div> -->
                                    <p class="mb-0">Share your details and we’ll get back to you as soon as possible.
                                    </p>
                                </div>

                                <div class="contact-card__body">
                                    <div class="form-group">
                                        <div class="row align-items-start g-3">
                                            <div class="col-md-4 col-lg-4">
                                                <label for="name" class="form-label">Name <span
                                                        class="text-danger">*</span></label>
                                            </div>
                                            <div class="col-md-8 col-lg-8">
                                                <input type="text" name="name" [formControlName]="'name'"
                                                    class="form-control" id="name" placeholder="Name" required>
                                                <div
                                                    *ngIf="contactFormGroup.get('name').invalid && (contactFormGroup.get('name').dirty || contactFormGroup.get('name') .touched || isSubmit)">
                                                    <div *ngIf="contactFormGroup.get('name').hasError('required')"
                                                        style="color: red;">Name
                                                        is required.</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div class="row align-items-start g-3">
                                            <div class="col-md-4 col-lg-4">
                                                <label for="email" class="form-label">Email <span
                                                        class="text-danger">*</span></label>
                                            </div>
                                            <div class="col-md-8 col-lg-8">
                                                <input type="email" name="email" [formControlName]="'email'"
                                                    class="form-control" id="email" placeholder="Email" required>
                                                <div
                                                    *ngIf="contactFormGroup.get('email').invalid && (contactFormGroup.get('email').dirty || contactFormGroup.get('email') .touched || isSubmit)">
                                                    <div *ngIf="contactFormGroup.get('email').hasError('required')"
                                                        style="color: red;">
                                                        Email is required.</div>
                                                    <div *ngIf="contactFormGroup.get('email').hasError('email')"
                                                        style="color: red;">
                                                        Please enter a valid email address.</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div class="row align-items-start g-3">
                                            <div class="col-md-4 col-lg-4">
                                                <label for="msg_subject" class="form-label">Subject <span
                                                        class="text-danger">*</span></label>
                                            </div>
                                            <div class="col-md-8 col-lg-8">
                                                <input type="text" name="msg_subject" [formControlName]="'subject'"
                                                    id="msg_subject" class="form-control" placeholder="Subject"
                                                    required>
                                                <div
                                                    *ngIf="contactFormGroup.get('subject').invalid && (contactFormGroup.get('subject').dirty || contactFormGroup.get('subject') .touched || isSubmit)">
                                                    <div *ngIf="contactFormGroup.get('subject').hasError('required')"
                                                        style="color: red;">
                                                        subject is required.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div class="row align-items-start g-3">
                                            <div class="col-md-4 col-lg-4">
                                                <label for="phone_number" class="form-label">Phone <span
                                                        class="text-danger">*</span></label>
                                            </div>
                                            <div class="col-md-8 col-lg-8">
                                                <input type="number" id="phone_number" class="form-control"
                                                    formControlName="phone_number" placeholder="Phone" />
                                                <div
                                                    *ngIf="contactFormGroup.get('phone_number').invalid && (contactFormGroup.get('phone_number').dirty || contactFormGroup.get('phone_number') .touched || isSubmit)">
                                                    <div *ngIf="contactFormGroup.get('phone_number').hasError('required')"
                                                        style="color: red;">
                                                        Phone number is required.
                                                    </div>
                                                    <div *ngIf="contactFormGroup.get('phone_number').hasError('pattern')"
                                                        style="color: red;">
                                                        Invalid phone number. Please enter a 10-digit number.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div class="row align-items-start g-3">
                                            <div class="col-md-4 col-lg-4">
                                                <label for="message" class="form-label">Comments <span
                                                        class="text-danger">*</span></label>
                                            </div>
                                            <div class="col-md-8 col-lg-8">
                                                <textarea name="message" id="message" [formControlName]="'message'"
                                                    class="form-control" cols="30" rows="6" required
                                                    placeholder="Comments"></textarea>
                                                <div
                                                    *ngIf="contactFormGroup.get('message').invalid && (contactFormGroup.get('message').dirty || contactFormGroup.get('message') .touched || isSubmit)">
                                                    <div *ngIf="contactFormGroup.get('message').hasError('required')"
                                                        style="color: red;">
                                                        Message is required.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="contact-card__actions text-center pt-2">
                                        <button type="submit" (click)="submitForm()"
                                            class="btn btn-blink">
                                            <span>Send Message</span>
                                            <i class="bi bi-arrow-right"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <!-- End Faq Area -->

    <!-- Newsletter Area -->
    <div class="newsletter-area">
        <div class="container">
            <div class="newsletter-content">
                <div class="row align-items-center">
                    <!-- <div class="col-lg-5 col-md-12">
                    <div class="newsletter-title">
                        <h3>Subscribe to our newsletter:</h3>
                        <p>Focused on the transport and lemonmode industry</p>
                    </div>
                </div>

                <div class="col-lg-7 col-md-12">
                    <form class="newsletter-form">
                        <input type="email" class="form-control" placeholder="Enter your email" name="EMAIL" required=""
                            autocomplete="off">
                        <button type="submit" class="btn btn-primary">Subscribe</button>
                    </form>
                </div> -->
                </div>
            </div>
        </div>
    </div>
    <!-- End Newsletter Area -->